<template>
  <div id="app">
    <div class="sticky-nav px-4">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Werven</h1>
      </div>

      <div class="dropdown">
        <button
          class="btn btn-dark"
          type="button"
          id="dropdownMenuButton"
          v-on:click="modalToevoegenWerf()"
        >
          <i class="fas fa-plus"></i> Werf toevoegen
        </button>
      </div>
    </div>

    <br /><br />

    <vue-good-table
      v-if="werven && werven.length"
      class="mb-3 px-4"
      @on-selected-rows-change="selectionChanged"
      @on-cell-click="onRowClick"
      :columns="werfColumns"
      :rows="werven"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: 100,
        position: 'bottom',
        perPageDropdown: [25, 50, 100],
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
        dropdownAllowAll: true,
      }"
      :selectOptions="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
      }"
    />

    <!-- Modal -->
    <div
      class="modal fade"
      id="werfModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ editModalTitle }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="werf">
              <label>Klant</label>
              <model-list-select
                :list="klanten"
                v-model="werf.klant"
                option-value="id"
                option-text="klantnaam"
                placeholder="- Kies een klant -"
              >
              </model-list-select>
              <hr />
              <label>Beschrijving</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.beschrijving"
                placeholder="Beschrijving"
              />
              <label>Straat</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.straat"
                placeholder="Straat"
              />
              <label>Huisnummer</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.huisnummer"
                placeholder="Huisnummer"
              />
              <label>Postcode</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.postcode"
                placeholder="Postcode"
              />
              <label>Gemeente</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.gemeente"
                placeholder="Gemeente"
              />
              <label>Land</label
              ><input
                type="text"
                class="form-control"
                v-model="werf.land"
                placeholder="Land"
              />
              <hr />
              <label>Contactpersoon</label>
              <input
                type="text"
                class="form-control"
                v-model="werf.contactpersoon"
                placeholder="Contactpersoon"
              />
              <label>Telefoon</label>
              <input
                type="text"
                class="form-control"
                v-model="werf.telefoon"
                placeholder="Telefoon"
              />
              <label>E-mail</label>
              <input
                type="text"
                class="form-control"
                v-model="werf.email"
                placeholder="E-mail"
              />
              <hr />
              <label>Plaatsing</label>
              <select class="form-control" v-model="werf.plaatsing">
                <option value="">- Kies plaatsingstype -</option>
                <option value="Openbaar">Openbaar</option>
                <option value="Privé">Privé</option>
              </select>
              <label>Opmerking</label>
              <textarea
                class="form-control"
                v-model="werf.opmerking"
                placeholder="Opmerking"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="checkNewWerf === false"
              type="button"
              class="btn btn-danger"
              v-on:click="deleteWerf()"
            >
              Verwijderen
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Sluiten
            </button>
            <button
              v-if="checkNewWerf"
              type="button"
              class="btn btn-primary"
              v-on:click="createWerf()"
            >
              Opslaan
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              v-on:click="updateWerf()"
            >
              Aanpassen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import axios from "axios";

import { ModelListSelect } from "vue-search-select";

export default {
  name: "app",
  components: {
    ModelListSelect,
  },
  data() {
    return {
      checkNewWerf: false,
      importType: "-1",
      importCategory: "-1",
      types: [
        {
          name: "Werven",
        },
        {
          name: "Werven",
        },
        {
          name: "Leveradressen",
        },
      ],
      editModalTitle: "",
      werf: {},
      klanten: [],
      werven: {
        attributes: [],
        related: [],
      },
      werfColumns: [
        {
          label: "Beschrijving",
          field: "beschrijving",
          filterOptions: { enabled: true },
        },
        {
          label: "Contactpersoon",
          field: "contactpersoon",
          filterOptions: { enabled: true },
        },
        {
          label: "Telefoon",
          field: "telefoon",
          filterOptions: { enabled: true },
        },
        {
          label: "Adres",
          field: this.adresFn,
          filterOptions: { enabled: true },
        },
        {
          label: "Postcode",
          field: "postcode",
          filterOptions: { enabled: true },
        },
        {
          label: "Gemeente",
          field: "gemeente",
          filterOptions: { enabled: true },
        },
        { label: "Land", field: "land", filterOptions: { enabled: true } },
      ],
      attrPos: 0,
    };
  },
  mounted() {
    this.getWerven();
    this.getKlanten();
  },
  methods: {
    contactFn(rowObj) {
      var contacten = this.contacten;
      var contact_id = rowObj.contact;

      for (var i = 0; i < contacten.length; i++) {
        if (contacten[i]["id"] == contact_id) {
          return contacten[i]["naam"] + " " + contacten[i]["voornaam"];
        }
      }
    },
    adresFn(rowObj) {
      return rowObj.straat + " " + rowObj.huisnummer;
    },
    getWerven() {
      axios.get("https://hofman.weblion.be/api/werven/").then((response) => {
        this.werven = response.data;
        console.log(this.werven);
      });
    },
    getKlanten() {
      axios.get("https://hofman.weblion.be/api/klanten/").then((response) => {
        this.klanten = response.data.sort(function(a, b) {
          var textA = a.klantnaam.toUpperCase();
          var textB = b.klantnaam.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        console.log(this.klanten);
      });
    },
    deleteWerf() {
      axios
        .delete("https://hofman.weblion.be/api/werven/", {
          data: {
            werf_id: this.werf.id,
          },
        })
        .then((response) => {
          this.getWerven();
          $("#werfModal").modal("hide");
          console.log(response.data);
        });
    },
    updateWerf() {
      axios
        .put("https://hofman.weblion.be/api/werven/", {
          werf: this.werf,
        })
        .then((response) => {
          this.getWerven();
          $("#werfModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    createWerf() {
      console.log(this.werf);

      axios
        .post("https://hofman.weblion.be/api/werven/", {
          werf: this.werf,
        })
        .then((response) => {
          this.getWerven();
          $("#werfModal").modal("hide");
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    modalToevoegenWerf() {
      this.werf = {};
      this.editModalTitle = "Werf toevoegen";

      this.checkNewWerf = true;

      $("#werfModal").modal("show");
    },
    onRowClick(table) {
      this.editModalTitle = "Werf aanpassen";
      this.werf = table.row;

      this.checkNewWerf = false;

      $("#werfModal").modal("show");
    },
    selectionChanged(table) {
      this.wervenSelected = table.selectedRows;
    },
    modalAanpassenWerf() {
      this.checkNewWerf = false;
      this.editModalTitle = "Werf aanpassen";

      $("#werfModal").modal("show");
    },
    sWerf() {
      axios
        .post("https://hofman.weblion.be/api/werven/update.php", {
          werf: this.werf,
        })
        .then((res) => {
          console.log(res);
          this.getWerven();
        })
        .then(function() {
          $("#werfModal").modal("hide");
        });
    },
  },
};
</script>

<style>
button {
  margin-right: 10px;
}
.table thead th {
  text-align: left !important;
}
.pager ul {
  list-style-type: none;
}
.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,
.modal select {
  margin-bottom: 5px;
}
.modal-body label {
  display: inline-block;
  width: 32%;
}

.modal-body .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

#importModal .modal-body label {
  width: auto;
}

#importModal input,
#importModal select {
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper,
#importModal form {
  width: 100%;
}
#importModal select {
  margin-left: 1%;
}

#importModal .fullw {
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select {
  margin: 0;
}

#importModal .fullw input {
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown {
  display: inline-block;
}
.dropdown-item:hover {
  cursor: pointer !important;
}
.dropdown-item i {
  margin-right: 3px;
}
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
}
.groupedState {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td {
  padding: 2px 10px;
}

#autoGroupModal .modal-title span {
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input {
  width: 100%;
}

#autoGroupModal .form-check-input {
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
  display: inline-block !important;
  width: 68% !important;
  margin-bottom: 5px !important;
}

.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}

#werfModal textarea {
  height: 100px;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}
.btn-danger {
  margin-right: 210px;
}
</style>
